import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import ChatHistorySidebar from './ChatHistorySidebar';
import { AppContext } from '../../context/AppContext';
import { HISTORY_ZERO_STATE } from '../../constants/HistoryConstants';
import ChatHistoryIcon from '../../assets/icon-history.svg?react';
import NewChatIcon from '../../assets/icon-topic.svg?react';
import './style.scss';
import { generateChatSessionId } from '../../utils/chat';
import OverlayTooltip from './UI/OverlayTooltip';
import AppDashBoardIcon from '../../assets/icon-app-dashboard.svg?react';
import useElysiaStore from '@/app/elysia-store';
import { DEFAULT_ASPECT_RATIO, DEFAULT_IMAGE_GEN_RESOLUTION } from '@/config/settings';

const Sidebar = () => {
  const { isSideNavOpen, setIsSideNavOpen } = useContext(AppContext);

  const isAppFileAttached = useElysiaStore((state) => state.isAppFileAttached);
  const brandDoc = useElysiaStore((state) => state.brandDoc);
  const chatAgent = useElysiaStore((state) => state.chatAgent);
  const isChatDisabled = useElysiaStore((state) => state.isChatDisabled);
  const isIntermediatePage = useElysiaStore((state) => state.isIntermediatePage);
  const setPromptInput = useElysiaStore.getState().setPromptInput;
  const setIsChatActive = useElysiaStore.getState().setIsChatActive;
  const setNewChat = useElysiaStore.getState().setNewChat;
  const setChatSessionId = useElysiaStore.getState().setChatSessionId;
  const setClearState = useElysiaStore.getState().setClearState;
  const setChatAgent = useElysiaStore.getState().setChatAgent;
  const setActiveChatHistoryRecord = useElysiaStore.getState().setActiveChatHistoryRecord;
  const setSessionPath = useElysiaStore.getState().setSessionPath;
  const setIsRestrictedChatSessionStatus =
    useElysiaStore.getState().setIsRestrictedChatSessionStatus;
  const setShowScrollIcon = useElysiaStore.getState().setShowScrollIcon;
  const setUploadedFileTitle = useElysiaStore.getState().setUploadedFileTitle;
  const setUploadedFile = useElysiaStore.getState().setUploadedFile;
  const setSources = useElysiaStore.getState().setSources;
  const setSelectedSources = useElysiaStore.getState().setSelectedSources;
  const setWordsCount = useElysiaStore.getState().setWordsCount;
  const setWordCountError = useElysiaStore.getState().setWordCountError;
  const setShowFileToasts = useElysiaStore.getState().setShowFileToasts;
  const setIsChatDisabled = useElysiaStore.getState().setIsChatDisabled;
  const setIsAddSourcesActive = useElysiaStore.getState().setIsAddSourcesActive;
  const resetAIApp = useElysiaStore.getState().resetAIApp;
  const setImageGenPayload = useElysiaStore.getState().setImageGenPayload;
  const setBrandDoc = useElysiaStore.getState().setBrandDoc;
  const setCategoryCount = useElysiaStore.getState().setCategoryCount;
  const setProfitCenter = useElysiaStore.getState().setProfitCenter;
  const setFinanceAppLocation = useElysiaStore.getState().setFinanceAppLocation;

  const navigate = useNavigate();

  const startNewTopicChat = () => {
    setIsAddSourcesActive?.(false);
    setShowScrollIcon?.(false);
    useElysiaStore.setState({ isStreamingStopped: false });
    setClearState?.(true);
    setNewChat?.(true);
    setChatSessionId?.(generateChatSessionId());
    if (chatAgent !== 'app-agent' || isIntermediatePage) {
      setChatAgent?.('Generic');
      resetAIApp();
    }
    setIsChatActive?.(false);
    setActiveChatHistoryRecord(HISTORY_ZERO_STATE);
    navigate('/', { replace: true });
    setPromptInput('');
    setSessionPath?.('');
    setIsRestrictedChatSessionStatus?.('');
    setUploadedFileTitle?.('');
    setUploadedFile?.(null);
    if (!isAppFileAttached) {
      setSources?.([]);
      setSelectedSources?.([]);
      setBrandDoc(false);
    }
    setWordsCount?.(0);
    setWordCountError?.(false);
    setShowFileToasts?.(false);
    setIsChatDisabled?.(false);
    setImageGenPayload({
      aspect_ratio: DEFAULT_ASPECT_RATIO,
      color_palette: [],
      // negative_prompt: '',
      starter_image_id: '',
      image_quality: DEFAULT_IMAGE_GEN_RESOLUTION,
    });
    setCategoryCount({});
    setProfitCenter({ value: '', label: '', level: 0, id: '' });
    setFinanceAppLocation({ value: '', label: '', level: 0, id: '' });
  };

  const handleAppDashboard = () => {
    navigate('/app-store');
  };
  return (
    <>
      <ChatHistorySidebar startNewTopicChat={startNewTopicChat} />
      <div className={`btn-container ${isSideNavOpen ? 'd-none' : ''}`}>
        <OverlayTooltip
          tooltipText="New Chat"
          buttonContent={<NewChatIcon />}
          ariaLabel="new chat"
          testId="new-chat-icon-button"
          tooltipClassName="tooltip-sidebar"
          buttonClassName="history-icon-wrapper fw-semibold"
          onClick={startNewTopicChat}
          disabled={isAppFileAttached && isChatDisabled && brandDoc}
        />

        <OverlayTooltip
          tooltipText="Chat History"
          buttonContent={<ChatHistoryIcon />}
          ariaLabel="chat history"
          testId="chat-history-button"
          tooltipClassName="tooltip-sidebar"
          buttonClassName="history-icon-wrapper fw-semibold"
          onClick={() => setIsSideNavOpen(!isSideNavOpen)}
        />
        <OverlayTooltip
          tooltipText="AI App Store"
          buttonContent={<AppDashBoardIcon />}
          ariaLabel="AI app store"
          testId="apps-dashboard-button"
          tooltipClassName="tooltip-sidebar"
          buttonClassName="dashboard-icon-wrapper fw-semibold"
          onClick={handleAppDashboard}
        />
      </div>
    </>
  );
};

export default Sidebar;
